export default function EngagementCard({ item, onOpen }) {
  const byline = [item.author, item.year].filter(Boolean).join(', ');
  return (
    <button
      type="button"
      onClick={() => onOpen(item)}
      className="card flex w-full flex-col items-start gap-2 text-left"
    >
      <h3 className="font-serif text-lg font-semibold text-cream">{item.title}</h3>
      {byline && <p className="text-sm text-ink-secondary">{byline}</p>}
      {item.description && (
        <p className="line-clamp-3 text-sm text-ink-secondary">{item.description}</p>
      )}
    </button>
  );
}
